import axios from 'axios';
import { toFromDates } from '../components/Common/cleanDates';
import {
  REQUEST_PURCHASE_ORDERS_BY_FILTER,
  FETCH_PURCHASE_ORDERS_SUCCESS,
  FETCH_PURCHASE_ORDERS_FAILURE,
} from './type';
import { PURCHASE_URL, PO_SET_QUOTE_TO_PLACED_URL } from './url';
import { 
  ROOT_URL, ROOT_API_URL, isOCM, isGGI, isABBLE, isSV, isVAK, isEKC, isLMH,
  isSDR, isCRW, isSC, isOLG, isSH
} from '../actions/root_url';

export function fetchPurchaseOrdersByFilter(
  context, postingDateGT, postingDateLT, days, orderStatus, orderUser, searchProductNum, 
  shipFromDate, shipToDate, orderType, searchText, searchParameterName, boln,
  loadingPort, limit, page, otherParams, isApprove = false, searchFilters ) {
  let status = orderStatus;
  let user = orderUser;
  let productNum = searchProductNum;
  const dates = toFromDates(days, postingDateGT, postingDateLT);
  const shipDates = toFromDates(-1, shipFromDate, shipToDate);

  if (status === 'all') {
    status = '';
  } else if (status === 'Partial') {
    status = '&PurchaseStatus=Partially%20Received';
  } else if(isApprove) {
    if(status === 'Reviewing') {
      status = `ReviewStatus=${status}`;
    } else if(status === 'Approving') {
      status = `ApproveStatus=${status}`;
    } else {
      status = `&PurchaseStatus=${status}`;
    }
  } else {
    status = `&PurchaseStatus=${status}`;
  }
  if (user) {
    user = `&Purchaser_User_id=${user}`;
  } else {
    user = '';
  }

  if (productNum) {
    productNum = `&ProductNum=${productNum}`;
  } else {
    productNum = '';
  }
  let type = {
    IsRelocation: false,
  };
  if (isOCM || isGGI) {
    type.IsTransfer = false;
  }
  if (orderType && context !== 'dropshipOrder') {
    type[orderType] = true;
  }

  let DropshipStatus = null;
  if ((isEKC || isLMH || isSDR || isCRW || isSC) && context === 'dropshipOrder' && orderType) {
    DropshipStatus = orderType;
  }

  let pageL = ``;
  let currentPage = '';
  let pageLimit = '';
  let limitL = ``;
  let otherParam = "";
  let searchParams = ""
  if ((isOCM || isVAK || isOLG || isSH) && context === 'purchaseOrder') {
    if (page !== null && page !== undefined) {
      pageL = `&page=${page + 1}`;
      currentPage = page;
    } else {
      pageL = `&page=1`;
      currentPage = 1;
    }
    if (limit !== null && limit !== undefined) {
      limitL = `&limit=${limit}`;
      pageLimit = limit;
    } else {
      limitL = `&limit=99999`;
    }
    if (otherParams) {
      otherParam = `&${otherParams}`
    }
  }
  if (isSV) {
    otherParam = otherParams;
  }
  if(isVAK && searchFilters &&  Object.keys(searchFilters).length){
    const sortKeyMap = {
      'PONum': 'order_num__icontains',
      'MfgNum': 'Mfg_Order_id__MfgNum__icontains',
      'OutsourcingNum': 'outsourcing_order__OutsourcingNum__icontains',
      'SubscriptionNum': 'subscription_order__order_num__icontains',
      'SubscriptionName': 'subscription_order__create_user_name__icontains',
      'VendorID': 'vendor__vendor_num__icontains',
      'VendorName': 'vendor__name__icontains',
      'container_num': 'container_num__icontains'
    }
    for (var key in searchFilters) {
      searchParams += `&${sortKeyMap[key]}=${searchFilters[key].filterTerm}`
    }
  }

  return (dispatch, getState) => {
    const state = getState();
    if (state.header.selectedWarehouse && state.header.selectedWarehouse.value) {
      dispatch({
        type: REQUEST_PURCHASE_ORDERS_BY_FILTER,
        payload: {
          dates,
          status,
          user,
          productNum,
          shipDates,
          type,
          searchText,
          searchParameterName,
          boln,
          loadingPort,
          DropshipStatus,
          pageL,
          currentPage,
          pageLimit,
          limitL,
          otherParam,
          searchParams,
        },
      });
    }
  };
}


export const deletePOImage = (imageid, success, failed) => {
  axios({
    method: 'DELETE',
    url: `${ROOT_URL}v1/purchase/po_images_delete/${imageid}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        failed();             
      }
    })
}

export const fetchPOImages = (poid, success, failed) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v2/purchase/order/${poid}?depth=1`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success(res);
    })
    .catch(err => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        failed();             
      }
    })
}

export const savePOImages = (poid, images, success, failed) => {
  let data = new FormData();
  for (let i = 0; i < images.length; i++) {
    data.append('images', images[i].file[0]);
  }
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/purchase/upload_po_images/${poid}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data,
  })
    .then(res => {
      success();
    })
    .catch(err => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        failed();             
      }
    })
}

export const uploadPOPOD = (poid, formData, success, failed) => dispatch => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/purchase/upload_pod_file/${poid}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data: formData,
  })
    .then(res => {
      success();
    })
    .catch(err => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        failed();             
      }
    })
}

export const setPO = (poid, success, failed) => dispatch => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}/v2/inventory/mergedraft/${poid}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      success();
    })
    .catch(err => {
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        failed(err);             
      }
    })
}

export const PurchaseOrderListEpic = (action$, { getState }) => {
  let savedAction;
  return action$.ofType(REQUEST_PURCHASE_ORDERS_BY_FILTER)
    .switchMap(action => {
      const state = getState();
      savedAction = action;
      const Company_id = state.header.selectedCompany.value;
      const warehouse_id = state.header.selectedWarehouse.value;
      const searchText = action.payload.searchText;
      const searchParameterName = action.payload.searchParameterName;
      const boln = action.payload.boln;
      const loadingPort = action.payload.loadingPort;
      const DropshipStatus = action.payload.DropshipStatus;
      const searchParams = action.payload.searchParams;
      let url = `${PURCHASE_URL}search/?${action.payload.status}${action.payload.user}${action.payload.productNum}&Company_id=${Company_id}&warehouse_id=${warehouse_id}`;
      if (searchText) {
        url += `&${searchParameterName}=${searchText}`;
      } else if(boln){
        url += `&boln=${boln}`
      } else if (loadingPort) {
        url += `&Loading_Port=${loadingPort}`
      } else {
        url += `&OrderDate__gte=${action.payload.dates.fromDate
        }&OrderDate__lte=${action.payload.dates.toDate}`
      }
      
      if (isABBLE ) {
        url += `&start_date__gte=${action.payload.shipDates.fromDate
        }&start_date__lte=${action.payload.shipDates.toDate}`
      }
      
      if ((isEKC || isLMH || isSDR || isCRW || isSC) && DropshipStatus) {
        url += `&DropshipStatus=${DropshipStatus}`;
      }
      if (isOCM || isVAK || isOLG || isSH) {
        const {pageL, limitL, otherParam} = action.payload;
        url += `${pageL}${limitL}${otherParam}`;
      }
      if (isSV) {
        url += action.payload.otherParam
      }
      if (isVAK && searchParams) {
        url += searchParams
      }
      return axios.get(
        url,
        {
          params: { ...action.payload.type },
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        },
      )
    })
    .map(response => {
      const payload = response;
      if (isOCM || isVAK || isOLG || isSH) {
        if (response.data.pages === undefined) {
          payload.data.totalPages = Math.ceil(response.data.rows / savedAction.payload.pageLimit);
        } else {
          payload.data.totalPages = response.data.pages;
        }
      }
      return { type: FETCH_PURCHASE_ORDERS_SUCCESS, payload }
    })
    .catch(err => ({ type: FETCH_PURCHASE_ORDERS_FAILURE, payload: err }));
}

export function quoteToPlaced(poId) {
  let data = {
    purchase_order_ids: poId,
  }
  
  return (dispatch) => {
    return axios({
      method: 'POST',
      url: `${PO_SET_QUOTE_TO_PLACED_URL}`,
      data,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      }
    )
    .then(response => {
      console.log('response: ', response)
    }, (err) => {
      alert(JSON.stringify(err.data));
    });
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/purchaseOrderList_actions.jsx